module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.3a8872f9.eot";